import { render, staticRenderFns } from "./CommentLoading.vue?vue&type=template&id=278b6f20&"
import script from "./CommentLoading.vue?vue&type=script&lang=js&"
export * from "./CommentLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports